import $ from 'jquery';
import { bindJQuery } from '@/scripts/helpers/library';
import { addedLazyLoadImages } from '@/scripts/helpers/lazyload';
import { commonLegacy } from '@/scripts/helpers/commonLegacy';
import 'slick-carousel/slick/slick';
import { BREAKPOINTS } from '@/scripts/helpers/constants';

const { TABLET_XL, DESKTOP } = BREAKPOINTS;
const mobileTrigger = $('.mobile-menu__trigger');
const mobileTriggerClose = $('.mobile-menu__close');
const mobileMenu = $('.mobile-menu');
const IS_VISIBLE = 'is-visible';

if(mobileMenu) {
  mobileTrigger.on('click', function () {
    mobileMenu.addClass(IS_VISIBLE);
  });

  mobileTriggerClose.on('click', function () {
    mobileMenu.removeClass(IS_VISIBLE);
  });
}

const showMore = () => {
  if ($('.js-show-more').length) {
    $('.js-show-more').on('click', function () {
      $(this).parent().toggleClass('is-open');
      const hiddenContent = $(this).parent().prev();
      const innerHeight = hiddenContent.find('.section-content__inner').outerHeight();
      hiddenContent.toggleClass('is-open');

      if (hiddenContent.hasClass('is-open')) {
        hiddenContent.css({ height: innerHeight });
      } else {
        hiddenContent.removeAttr('style');
      }
    });
  }
};

const initOtherFormsSlider = () => {
  const otherFormsSlider = $('.js-other-forms-slider');
  const prevArrow = `
    <button type="button" class="slider-arrow slider-arrow--prev">
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle r="23.5" transform="matrix(-1 0 0 1 24 24)" fill="none" stroke="#22C29A"/>
        <path id="Path 4" d="M23.6055 18L17.6055 24L23.6055 30" stroke="#22C29A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path id="Path 5" d="M17.6055 24H29" stroke="#22C29A" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  `;
  const nextArrow = `
    <button type="button" class="slider-arrow slider-arrow--next">
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="23.5" stroke="#22C29A"/>
        <path id="Path 4" d="M24.3945 18L30.3945 24L24.3945 30" stroke="#22C29A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path id="Path 5" d="M30.3945 24H19" stroke="#22C29A" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  `;

  if (otherFormsSlider.length) {
    otherFormsSlider.slick({
      infinite: true,
      focusOnSelect: false,
      pauseOnFocus: false,
      arrows: true,
      adaptiveHeight: true,
      prevArrow,
      nextArrow,
      cssEase: 'linear',
      variableWidth: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: TABLET_XL,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
          },
        },
        {
          breakpoint: DESKTOP,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
          },
        },
      ],
    });
  }
};

const setSmoothAnchorsScroll = () => {
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        && location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        let target = $(this.hash);
        target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top,
          }, 1000, () => {
            // Callback after animation
            // Must change focus!
            const $target = $(target);
            $target.focus();
            if ($target.is(':focus')) { // Checking if the target was focused
              return false;
            }
            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          });
        }
      }
    });
};

$(document).ready(() => {
  addedLazyLoadImages();
  bindJQuery();
  commonLegacy();
  showMore();
  initOtherFormsSlider();
  setSmoothAnchorsScroll();

  const selector = {
    loaderTrigger: '[data-loader]',
    percentage: '.percentage',
    loader: '.js-loader',
    circle: '.loader .circle',
  };

  function showLoader() {
    $(selector.loader).addClass('is-show');
  }

  function animateCount(el) {
    $(el).each(function () {
      const $this = $(this);
      $({ Counter: 0 }).animate({
        Counter: $this.text(),
      }, {
        duration: 2800,
        easing: 'swing',
        step: function stepFn() {
          $this.text(`${Math.ceil(this.Counter)}%`);
        },
      });
    });
  }

  function animateCircle(el) {
    $(el).each(function () {
      const $this = $(this);
      $({ Counter: 100 }).animate({
        Counter: $this.attr('stroke-dashoffset'),
      }, {
        duration: 2800,
        easing: 'swing',
        step: function stepFn() {
          $this.attr('stroke-dashoffset', this.Counter);
        },
      });
    });
  }

  $(selector.loaderTrigger).on('click', (e) => {
    e.preventDefault();

    if ($(selector.loader).length) { // if loader markup exist in DOM
      showLoader();
      animateCircle(selector.circle);
      animateCount(selector.percentage);
      $('body').addClass('modal-open');
      $('body').keyup((evt) => {
        if (evt.keyCode === 27 || evt.which === 27) {
          evt.preventDefault();
        }
      });
    }
  });

  window.addEventListener('pageshow', (evt) => {
    if (evt.persisted) {
      setTimeout(() => {
        window.location.reload();
      }, 10);
    }
  }, false);

  function showDetails() {
    $('.js-section-details').toggleClass('is-open');
  }

  $('.js-details-show, .js-details-hide').on('click', showDetails);
  $('.js-details-show, .js-details-hide').on('keydown', (e) => {
    if (e.key === 'Enter') {
      showDetails();
    }
  });

  const initBenefitFromCarousel = () => {
    const benefitFromCarousel = $('.js-benefit-from-carousel');
    const windowWidth = $(window).width();
    const destroyBreakpoint = 830;

    if (windowWidth > destroyBreakpoint) {
      if (benefitFromCarousel.hasClass('slick-initialized')) {
        benefitFromCarousel.slick('unslick');
      }
    } else if (benefitFromCarousel.length) {
      benefitFromCarousel.not('.slick-initialized').slick({
        dots: true,
        arrows: false,
        cssEase: 'linear',
        speed: 150,
        autoplaySpeed: 4000,
        autoplay: false,
        infinite: true,
        centerMode: true,
        variableWidth: true,
        pauseOnHover: true,
        pauseOnFocus: false,
        pauseOnDotsHover: !(
          !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        ),
      });
    }
  };
  $(window).on('load resize', initBenefitFromCarousel);
});
